import { render, staticRenderFns } from "./EditFormSectionComponent.vue?vue&type=template&id=6b6199b6&"
import script from "./EditFormSectionComponent.vue?vue&type=script&lang=js&"
export * from "./EditFormSectionComponent.vue?vue&type=script&lang=js&"
import style0 from "./EditFormSectionComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports